import { Activity, TrendingUp, Sparkles } from 'lucide-react';

export default function HealthSummaryCards({ healthSummary }) {
  if (!healthSummary || healthSummary.data_entries === 0) return null;

  return (
    <div className="mt-8 mb-6" data-testid="health-summary-cards">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
        <Activity className="w-6 h-6 mr-2 text-emerald-600" />
        Health Data Summary
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-lg shadow-lg p-6">
          <div className="flex items-center justify-between mb-2">
            <Activity className="w-8 h-8 text-red-500" />
            <span className="text-2xl font-bold text-red-600">
              {Math.round(healthSummary.avg_heart_rate || 0)}
            </span>
          </div>
          <h3 className="text-sm font-medium text-gray-700">Avg Heart Rate</h3>
          <p className="text-xs text-gray-500">bpm</p>
        </div>

        <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg shadow-lg p-6">
          <div className="flex items-center justify-between mb-2">
            <TrendingUp className="w-8 h-8 text-green-500" />
            <span className="text-2xl font-bold text-green-600">
              {Math.round(healthSummary.avg_steps_per_day || 0)}
            </span>
          </div>
          <h3 className="text-sm font-medium text-gray-700">Avg Steps</h3>
          <p className="text-xs text-gray-500">per day</p>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-lg shadow-lg p-6">
          <div className="flex items-center justify-between mb-2">
            <Activity className="w-8 h-8 text-blue-500" />
            <span className="text-2xl font-bold text-blue-600">
              {Math.round(healthSummary.avg_exercise_minutes_per_day || 0)}
            </span>
          </div>
          <h3 className="text-sm font-medium text-gray-700">Avg Exercise</h3>
          <p className="text-xs text-gray-500">minutes/day</p>
        </div>

        <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-lg shadow-lg p-6">
          <div className="flex items-center justify-between mb-2">
            <Sparkles className="w-8 h-8 text-purple-500" />
            <span className="text-2xl font-bold text-purple-600">
              {healthSummary.avg_sleep_hours_per_night?.toFixed(1) || '0.0'}
            </span>
          </div>
          <h3 className="text-sm font-medium text-gray-700">Avg Sleep</h3>
          <p className="text-xs text-gray-500">hours/night</p>
        </div>
      </div>
    </div>
  );
}
